var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.347,
    height: 24,
    viewBox: "0 0 21.347 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.347,
    height: 24,
    fill: "#595959"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.878,227.361c0-.07,0-.14,0-.211,0-.129,0-.258.009-.385a.979.979,0,0,1,.76-.918,1.553,1.553,0,0,1,.862.022.962.962,0,0,1,.663.752,1.564,1.564,0,0,1,.026.341c0,.118,0,.236,0,.354,0,.015,0,.03,0,.047a.109.109,0,0,1,.1.1.9.9,0,0,1-.061.526,1.231,1.231,0,0,1-.239.373.133.133,0,0,0-.026.052,1.211,1.211,0,0,1-.4.609.871.871,0,0,1-.528.2.805.805,0,0,1-.384-.093,1.038,1.038,0,0,1-.452-.44c-.05-.091-.082-.192-.124-.288a.18.18,0,0,0-.029-.051,1.1,1.1,0,0,1-.305-.647,1.16,1.16,0,0,1,.011-.246c.008-.068.035-.089.1-.106",
    transform: "translate(-23.056 -210.264)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.431,284.9H4.206l-1.075,1.429a.19.19,0,0,1-.355,0l-1-1.425H1.539A1.539,1.539,0,0,0,0,286.44v2.227a.635.635,0,0,0,.635.635h4.7a.635.635,0,0,0,.635-.635V286.44a1.54,1.54,0,0,0-1.54-1.54",
    transform: "translate(0 -265.302)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.408,227.361c0-.07,0-.14,0-.211,0-.129,0-.258.009-.385a.979.979,0,0,1,.76-.918,1.553,1.553,0,0,1,.862.022.962.962,0,0,1,.663.752,1.564,1.564,0,0,1,.026.341c0,.118,0,.236,0,.354,0,.015,0,.03,0,.047a.109.109,0,0,1,.1.1.9.9,0,0,1-.061.526,1.231,1.231,0,0,1-.239.373.133.133,0,0,0-.026.052,1.211,1.211,0,0,1-.4.609.871.871,0,0,1-.528.2.805.805,0,0,1-.384-.093,1.038,1.038,0,0,1-.452-.44c-.05-.091-.082-.192-.124-.288a.18.18,0,0,0-.029-.051,1.1,1.1,0,0,1-.306-.647,1.162,1.162,0,0,1,.012-.246c.008-.068.035-.089.1-.106",
    transform: "translate(-231.21 -210.264)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.961,284.9h-.225l-1.075,1.429a.19.19,0,0,1-.355,0l-1-1.425h-.242a1.539,1.539,0,0,0-1.539,1.54v2.227a.635.635,0,0,0,.635.635h4.7a.635.635,0,0,0,.635-.635V286.44a1.54,1.54,0,0,0-1.54-1.54",
    transform: "translate(-208.154 -265.302)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,227.361c0-.07,0-.14,0-.211,0-.129,0-.258.009-.385a.979.979,0,0,1,.76-.918,1.552,1.552,0,0,1,.862.022.962.962,0,0,1,.663.752,1.563,1.563,0,0,1,.026.341c0,.118,0,.236,0,.354,0,.015,0,.03,0,.047a.109.109,0,0,1,.1.1.9.9,0,0,1-.061.526,1.231,1.231,0,0,1-.239.373.134.134,0,0,0-.026.052,1.211,1.211,0,0,1-.4.609.871.871,0,0,1-.528.2.805.805,0,0,1-.384-.093,1.038,1.038,0,0,1-.452-.44c-.05-.091-.082-.192-.124-.288a.18.18,0,0,0-.029-.051,1.1,1.1,0,0,1-.305-.647,1.161,1.161,0,0,1,.011-.246c.008-.068.035-.089.1-.106",
    transform: "translate(-127 -210.264)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.054,284.9h-.225l-1.075,1.429a.19.19,0,0,1-.355,0l-1-1.425h-.242a1.539,1.539,0,0,0-1.539,1.54v2.227a.635.635,0,0,0,.635.635h4.7a.635.635,0,0,0,.635-.635V286.44a1.54,1.54,0,0,0-1.54-1.54",
    transform: "translate(-103.945 -265.302)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.981,2.707c0-.12,0-.243,0-.365,0-.222,0-.446.016-.667A1.694,1.694,0,0,1,124.312.087,2.686,2.686,0,0,1,125.8.125a1.664,1.664,0,0,1,1.148,1.3,2.694,2.694,0,0,1,.045.59c0,.2,0,.408.006.612,0,.026,0,.052.005.082a.189.189,0,0,1,.179.18,1.551,1.551,0,0,1-.105.909,2.127,2.127,0,0,1-.413.646.232.232,0,0,0-.045.09,2.1,2.1,0,0,1-.688,1.054,1.507,1.507,0,0,1-.914.352,1.392,1.392,0,0,1-.665-.16,1.8,1.8,0,0,1-.782-.76c-.087-.158-.143-.332-.214-.5a.312.312,0,0,0-.05-.088,1.911,1.911,0,0,1-.529-1.119,2.007,2.007,0,0,1,.02-.426c.014-.118.061-.155.181-.183",
    transform: "translate(-114.33 0)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.609,102.247h-.39l-1.859,4.691a.329.329,0,0,1-.614-.008l-1.722-4.683h-.418a2.663,2.663,0,0,0-2.663,2.663v3.853a1.1,1.1,0,0,0,1.1,1.1h8.131a1.1,1.1,0,0,0,1.1-1.1V104.91a2.663,2.663,0,0,0-2.663-2.663",
    transform: "translate(-74.444 -95.214)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.505,100.86h1.145l.109.267a.272.272,0,0,1-.037.27l-.429.551.225,1.577-.451,1.089-.451-1.089.225-1.577-.377-.571a.272.272,0,0,1-.04-.229Z",
    transform: "translate(-134.483 -93.922)",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveIcon);
export default __webpack_public_path__ + "static/media/Wave-icon.20b54a549aba64eeee96d3a2bd11d049.svg";
export { ForwardRef as ReactComponent };